import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

function AuthShell({ title, subtitle, quote, children }) {
  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 bg-gray-50 flex flex-col justify-center p-8 sm:p-12 lg:p-16 relative">
        <div className="absolute top-6 left-6 sm:top-8 sm:left-8">
          <img src="/logo-1.png" alt="Elyspr" className="h-28 w-auto" />
        </div>

        <div className="max-w-lg mt-10 lg:mt-0">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight leading-tight">{title}</h1>
          <p className="mt-4 text-lg text-gray-700 font-medium leading-relaxed">{subtitle}</p>
          <p className="mt-10 text-xl text-gray-800 italic leading-relaxed">“{quote}”</p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-black flex flex-col justify-center p-8 sm:p-12 lg:p-16">
        <div className="w-full max-w-md mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-300 hover:text-white mb-8 transition-colors"
          >
            <FiArrowLeft className="text-base" />
            <span className="text-sm font-medium">Back to Home</span>
          </Link>

          {children}
        </div>
      </div>
    </div>
  );
}

export default AuthShell;
